/* eslint-disable max-len */
import { environment } from '@environment';

export const bookingApi = {
  air_validation: `${environment.api.services}/api/travel-proxy-ms/air/validation`,
  air_validation_by_sector: `${environment.api.services}/api/travel-proxy-ms/air/by-sector/validation`,
  hotel_validation: `${environment.api.services}/api/travel-proxy-ms/hotel/validation`,
  hotel_validation_byhours: `${environment.api.services}/api/travel-proxy-ms/hotel/validate/micro-stay`,
  auto_validation: `${environment.api.services}/api/travel-proxy-ms/vehicle/validate`,
  package_validate: `${environment.api.services}/api/travel-proxy-ms/package/validate`,
  activities_validate: `${environment.api.services}/api/travel-proxy-ms/travel-extra/validate`,
  air_book: `${environment.api.services}/api/travel-proxy-ms/air/book`,
  air_book_by_sector: `${environment.api.services}/api/travel-proxy-ms/air/by-sector/book`,
  hotel_book: `${environment.api.services}/api/travel-proxy-ms/hotel/book`,
  auto_book: `${environment.api.services}/api/travel-proxy-ms/vehicle/book`,
  package_book: `${environment.api.services}/api/travel-proxy-ms/package/book`,
  activities_book: `${environment.api.services}/api/travel-proxy-ms/travel-extra/book`,
  rappi_payment: `${environment.api.services}/api/travel-intermediary-ms/summary-branch?token={TravelItineraryId}`,
  rappi_intermediary_payment: `${environment.api.services}/api/ms/sh-cart-intermediary/viajes/initialization`,
  exchange_rate: `${environment.api.services}/api/travel-proxy-ms/payments/exchangerate?fromCurrency={currencyFrom}&toCurrency={currencyTo}`,
  terms_and_conditions: `${environment.api.services}/api/ms/terms-and-conditions/user/accept-specific-policies`,
};
